import PropTypes from 'prop-types';
import React, {
  useCallback,
  useMemo,
  useState,
} from 'react';
import { useMutation } from '@apollo/client';
import FlagDialog from 'components/FlagDialog';
// import tracker, { TrackerFragments } from 'lib/tracker';
import { REPORT_COMMENT } from '../../../schema/apolloMutations/FeedMutations';

const FlagCommentDialog = ({
  comment,
  onRequestClose,
  open = false,
  viewer,
  personId,
  onRefresh,
}) => {
  const [reportComment] = useMutation(REPORT_COMMENT);
  const { flagged, flaggedDate, flaggedReason } = comment;
  const [saving, setSaving] = useState(false);
  const trackerData = useMemo(
    () => ({
      comment,
      viewer,
    }),
    [
      comment,
      viewer,
    ],
  );
  const onSubmit = useCallback(
    ({ reason }, { setErrors, setSubmitting }) => {
      // eslint-disable-next-line no-console
      console.log('Resons', reason);
      setSaving(true);
      reportComment({
        variables: {
          report: {
            comment: reason,
            feedType: 'Discussion',
            id: comment.id,
            personId,
          },
        },
      }).then(res => {
        if (res) {
          onRefresh();
          setSaving(false);
          setSubmitting(false);
          onRequestClose();
        }
      }).catch(e => {
        setErrors(e);
        setSaving(false);
        setSubmitting(false);
      });
      // relay.commitUpdate(
      //   new FlagCommentMutation({
      //     comment,
      //     reason,
      //   }),
      //   {
      //     onFailure: transaction => {
      //       const {
      //         message,
      //         validationErrors,
      //       } = extractTransactionError(transaction);
      //       setErrors(validationErrors);
      //       setSaving(false);
      //       setSubmitting(false);
      //       tracker.trackGoogleAnalyticsException(
      //         message,
      //         trackerData,
      //       );
      //     },
      //     onSuccess: () => {
      //       setSaving(false);
      //       setSubmitting(false);
      //       onRequestClose();
      //       tracker.trackGoogleAnalyticsEvent(
      //         'Media',
      //         'Flag for moderation',
      //         trackerData,
      //       );
      //     },
      //   },
      // );
    },
    [
      comment,
      onRequestClose,
      // relay,
      trackerData,
    ],
  );
  return (
    <FlagDialog
      flagged={flagged}
      flaggedDate={flaggedDate}
      flaggedReason={flaggedReason}
      onRequestClose={onRequestClose}
      onSubmit={onSubmit}
      open={open}
      saving={saving}
      type='comment'
    />
  );
};

FlagCommentDialog.propTypes = {
  comment: PropTypes.object.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  viewer: PropTypes.object.isRequired,
  personId: PropTypes.object.isRequired,
  onRefresh: PropTypes.func.isRequired,
};

export default FlagCommentDialog;
